import TruncatedString from "components/shared/truncatedString";
import TypeOptions from "components/shared/typeOptionsShow";
import React, { Component, Fragment } from "react";

export default class CargoPoints extends Component {
    renderTypeOptions = (cargo) => {
        const { typeOptions } = cargo;
        if (!typeOptions || typeOptions.length === 0) {
            return null;
        }
        const { enums, userEntityOptions } = this.props;
        const props = { typeOptions, enums, userEntityOptions };
        return <TypeOptions {...props} />;
    };

    renderCargo = (cargo, i) => {
        const { enums, canUseMultipleBidCargos } = this.props;
        const {
            id,
            name,
            loadingTypeId,
            unloadingTypeId,
            typeId,
            width,
            height,
            volume,
            length,
            weight,
            temperatureHint,
            comment,
            packType,
            placesCount,
        } = cargo;
        const loadUnload = [
            enums.loadingType.find((item) => item.value === loadingTypeId),
            enums.unloadingType.find((item) => item.value === unloadingTypeId),
        ]
            .filter((item) => item)
            .map((item) => item.label)
            .join(", ");
        const cargoTypeObj = enums.cargoType.find((item) => item.value === typeId);
        const sizes = [
            { label: `Вес: ${weight}т`, value: weight },
            { label: `Объем: ${volume}м3`, value: volume },
            { label: `Длина: ${length}м`, value: length },
            { label: `Ширина: ${width}м`, value: width },
            { label: `Высота: ${height}м`, value: height },
            { label: `Температура: ${temperatureHint}`, value: temperatureHint },
        ]
            .filter((item) => item.value || item.value === 0)
            .map((item) => item.label)
            .join(", ");

        return (
            <Fragment key={id}>
                <div className="show-bid__section-header">{canUseMultipleBidCargos && `#${i + 1} `}Груз</div>
                <div className="show-bid__cargo-container">
                    <div className="show-bid__cargo-info">
                        <div className="show-bid__main-info--title">Наименование</div>
                        <div className="show-bid__main-info--value" data-test-id="cargo-name">
                            {name}
                        </div>
                        <div className="show-bid__main-info--title">Тип товара</div>
                        <div className="show-bid__main-info--value" data-test-id="cargo-type">
                            {cargoTypeObj ? cargoTypeObj.label : ""}
                        </div>
                        {!!comment && (
                            <>
                                <div className="show-bid__main-info--title">Комментарий</div>
                                <div className="show-bid__main-info--value" data-test-id="cargo-comment">
                                    <TruncatedString text={comment} />
                                </div>
                            </>
                        )}
                        {!!loadUnload && (
                            <>
                                <div className="show-bid__main-info--title">Способ загрузки и выгрузки</div>
                                <div className="show-bid__main-info--value" data-test-id="cargo-load-unload">
                                    {loadUnload}
                                </div>
                            </>
                        )}
                        {!!packType && (
                            <>
                                <div className="show-bid__main-info--title">Тип упаковки</div>
                                <div className="show-bid__main-info--value" data-test-id="cargo-pack-type">
                                    {packType}
                                </div>
                            </>
                        )}
                        {placesCount !== null && placesCount !== undefined && (
                            <>
                                <div className="show-bid__main-info--title">Количество мест</div>
                                <div className="show-bid__main-info--value" data-test-id="cargo-places-count">
                                    {placesCount}
                                </div>
                            </>
                        )}
                        {!!sizes && (
                            <>
                                <div className="show-bid__main-info--title">Габариты</div>
                                <div className="show-bid__main-info--value" data-test-id="cargo-size">
                                    {sizes}
                                </div>
                            </>
                        )}
                        {this.props.renderExtendedProperties(
                            this.props.extendedPropertiesConfig.cargo,
                            cargo.extendedProperties,
                        )}
                        {this.renderTypeOptions(cargo)}
                    </div>
                </div>
            </Fragment>
        );
    };

    render() {
        const { cargos } = this.props.bid;
        return cargos.map((item, i) => this.renderCargo(item, i));
    }
}
